var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddDiploma = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Essentional, UI / Add Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6253 7.49996C10.6253 7.15478 10.3455 6.87496 10.0003 6.87496C9.65515 6.87496 9.37533 7.15478 9.37533 7.49996L9.37533 9.37498H7.50033C7.15515 9.37498 6.87533 9.6548 6.87533 9.99998C6.87533 10.3452 7.15515 10.625 7.50033 10.625H9.37533V12.5C9.37533 12.8451 9.65515 13.125 10.0003 13.125C10.3455 13.125 10.6253 12.8451 10.6253 12.5L10.6253 10.625H12.5003C12.8455 10.625 13.1253 10.3452 13.1253 9.99998C13.1253 9.6548 12.8455 9.37498 12.5003 9.37498H10.6253V7.49996Z",
    fill: "#58607C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.04163C5.05277 1.04163 1.04199 5.05241 1.04199 9.99996C1.04199 14.9475 5.05277 18.9583 10.0003 18.9583C14.9479 18.9583 18.9587 14.9475 18.9587 9.99996C18.9587 5.05241 14.9479 1.04163 10.0003 1.04163ZM2.29199 9.99996C2.29199 5.74276 5.74313 2.29163 10.0003 2.29163C14.2575 2.29163 17.7087 5.74276 17.7087 9.99996C17.7087 14.2572 14.2575 17.7083 10.0003 17.7083C5.74313 17.7083 2.29199 14.2572 2.29199 9.99996Z",
    fill: "#58607C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddDiploma);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addDiploma.baecaa9a88f1bc4ad59afaea216aa2bc.svg";